module.exports = __webpack_public_path__ + "html/link-api.template.html";